import Select from "@material-ui/core/esm/Select";
import MenuItem from "@material-ui/core/esm/MenuItem";
import FormControl from "@material-ui/core/esm/FormControl";
import ListItemText from "@material-ui/core/esm/ListItemText";
import Checkbox from "@material-ui/core/esm/Checkbox";
import { nanoid } from 'nanoid';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BoldSubtitle } from 'components/Text';
import useStyles, { MenuProps } from './FormStyles';
const idSuffix = nanoid();
export default function MultipleSelectComponent({
  id,
  items,
  defaultItems = [],
  label,
  onChange
}) {
  const [selected, setSelected] = useState(defaultItems);
  const {
    multipleSelect
  } = useStyles();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    if (defaultItems) {
      setSelected(defaultItems);
      onChange(defaultItems);
    }
  }, [defaultItems, setSelected, onChange]);
  const handleChange = event => {
    let value = event.target.value;
    if (value[value.length - 1] === 'all') {
      value = selected.length === items.length ? [] : items.map(i => i.value);
    }
    setSelected(value);
    onChange(value);
  };
  const labelId = `${label}_${idSuffix}`;
  return /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    className: multipleSelect
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    id: labelId
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, label)), /*#__PURE__*/React.createElement(Select, {
    labelId: id,
    id: id,
    value: selected,
    onChange: handleChange,
    variant: "outlined",
    defaultValue: defaultItems,
    disabled: !items?.length,
    multiple: true,
    displayEmpty: true,
    renderValue: () => {
      if (!selected.length) return t('multiple_select.no_selected');
      if (selected.length === items.length) return t('multiple_select.all_selected');
      if (selected.length === 1) return items?.find(i => i.value === selected[0])?.label;
      return t('multiple_select.multiple_selected');
    },
    MenuProps: MenuProps
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "all"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: selected.length === items?.length,
    indeterminate: selected.length > 0 && selected.length < items?.length
  }), /*#__PURE__*/React.createElement(ListItemText, null, t('multiple_select.select_all'))), items?.map(({
    value,
    label: itemLabel
  }) => /*#__PURE__*/React.createElement(MenuItem, {
    key: value,
    value: value
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: selected.indexOf(value) > -1
  }), /*#__PURE__*/React.createElement(ListItemText, null, itemLabel)))));
}
MultipleSelectComponent.defaultProps = {
  defaultItems: []
};